const DEFAULT_LOCALE = 'en-US';

module.exports = {
    DEFAULT_LOCALE,
};
